export default __webpack_public_path__ + "static/media/laianemlira.9d024e75.jpg";